import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';

const TONES = {
  default: 'border-[#5a3418] text-[#ffe9b8] bg-[#1a0e05] hover:border-[#f5a623] hover:text-[#ffc968]',
  accent: 'border-[#1a0e05] text-[#1a0e05] bg-[#f5a623] hover:bg-[#ffc968] shadow-[2px_2px_0_#1a0e05]',
  danger: 'border-[#7a2a14] text-[#ff8a5c] bg-[#1a0e05] hover:border-[#ff6a3a] hover:text-[#ff6a3a]'
};

export function ActionBtn({ children, onClick, disabled, label, testId, tone = 'default' }) {
  return (
    <button type="button" onClick={onClick} disabled={disabled} aria-label={label} title={label} data-testid={testId}
            className={`admin-action h-11 min-w-[2.75rem] px-3 border-2 rounded-md flex items-center justify-center gap-1.5 font-osd text-xs tracking-widest transition-[background-color,border-color,color,transform] active:translate-y-px disabled:opacity-25 disabled:cursor-not-allowed ${TONES[tone]}`}>
      {children}
    </button>
  );
}

export function MoveButtons({ index, total, onMove, label, upTestId, downTestId }) {
  return (
    <div className="flex items-center gap-1.5" role="group" aria-label={`Reorder ${label}`}>
      <ActionBtn onClick={() => onMove(index, -1)} disabled={index === 0} label={`Move ${label} up`} testId={upTestId}>
        <ArrowUp className="w-4 h-4" /><span className="hidden min-[420px]:inline">UP</span>
      </ActionBtn>
      <span className="font-osd text-[11px] text-[#a88552] tracking-widest min-w-[3.25rem] text-center tabular-nums" aria-hidden>
        {index + 1} / {total}
      </span>
      <ActionBtn onClick={() => onMove(index, 1)} disabled={index === total - 1} label={`Move ${label} down`} testId={downTestId}>
        <ArrowDown className="w-4 h-4" /><span className="hidden min-[420px]:inline">DOWN</span>
      </ActionBtn>
    </div>
  );
}

export const moveItem = (list, idx, dir) => {
  const next = [...list];
  const [row] = next.splice(idx, 1);
  next.splice(idx + dir, 0, row);
  return next;
};
